export type StayRange = { startDate: string; endDate: string };

export type DraftResource = {
  id: string;
  name: string;
  color: string | null;
  blockedRanges: StayRange[];
  airbnbBlockedRanges?: StayRange[];
  ownPendings: Array<{ id: string; startDate: string; endDate: string }>;
};

export type ResourceStayState = 'free' | 'airbnb' | 'taken';

export function stayNights(checkIn: string, checkOut: string): number {
  const a = Date.parse(`${checkIn}T00:00:00.000Z`);
  const b = Date.parse(`${checkOut}T00:00:00.000Z`);
  if (!Number.isFinite(a) || !Number.isFinite(b)) return 0;
  return Math.round((b - a) / 86_400_000);
}

function rangesOverlap(a: StayRange, b: StayRange): boolean {
  return a.startDate < b.endDate && a.endDate > b.startDate;
}

export function resourceStayState(
  resource: DraftResource,
  checkIn: string,
  checkOut: string
): ResourceStayState {
  if (stayNights(checkIn, checkOut) < 2) return 'taken';
  const stay = { startDate: checkIn, endDate: checkOut };
  if (resource.blockedRanges.some((b) => rangesOverlap(stay, b))) return 'taken';
  for (const pending of resource.ownPendings) {
    const range = { startDate: pending.startDate, endDate: pending.endDate };
    const same = pending.startDate === checkIn && pending.endDate === checkOut;
    if (rangesOverlap(stay, range) && !same) return 'taken';
  }
  if ((resource.airbnbBlockedRanges ?? []).some((b) => rangesOverlap(stay, b))) return 'airbnb';
  return 'free';
}

/** Lista completa. El recurso del chat se preselecciona en la hoja. */
export function resourcesForSelector(resources: DraftResource[]): DraftResource[] {
  return resources;
}

export function formatStayDate(isoDay: string): string {
  const d = new Date(`${isoDay}T00:00:00.000Z`);
  return d.toLocaleDateString('es-UY', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}

export function isoDay(value: string | null | undefined): string | null {
  if (!value) return null;
  const match = /^(\d{4}-\d{2}-\d{2})/.exec(value.trim());
  return match?.[1] ?? null;
}
